import { LitElement, html, css } from 'lit';
import { accessibility } from '../../utilities/styles';
export class AllAltBlock extends LitElement {
    static properties = {
        description: { type: String },
        uid: { type: String },
    };
    constructor() {
        super();
        if (!this.description) {
            this.description = `Addurnol`;
        }
    }
    render() {
        return html `<div class = "alt_block">\n\t\t\t<button class="alt_trigger" aria-label=${msg `Show alt text`} @click=${this._openAltBlock}>Amgen</button>\n\t\t\t<div class="alt_modal" id=${this.uid} role="dialog" aria-label=${`Testun amgen`} aria-describedby=${`desc_${this.uid}`}>\n\t\t\t\t<p id=${`desc_${this.uid}`}>${this.description}</p>\n\t\t\t\t<button class="close" @click=${this._closeAltBlock}>Cau <span class="screen-reader-text">testun amgen</span></button>\n\t\t\t</div>\n\t\t</div>`;
    }
    _openAltBlock(e) {
        e.preventDefault();
        const target = e.currentTarget;
        const block = target.parentNode;
        block.classList.add('open');
        let closer = block.querySelector('.close');
        closer.focus();
        block.addEventListener("keydown", this._altKeyHandler);
    }
    _closeAltBlock(e) {
        const target = e.currentTarget;
        const block = target.closest('.alt_block');
        block.classList.remove('open');
        let trigger = block.querySelector('.alt_trigger');
        trigger.focus();
        block.removeEventListener("keydown", this._altKeyHandler);
    }
    _altKeyHandler(e) {
        if (e.key == "Escape") {
            e.preventDefault();
            e.currentTarget.classList.remove('open');
            let trigger = e.currentTarget.querySelector('.alt_trigger');
            trigger.focus();
            e.currentTarget.removeEventListener("keydown", this._altKeyHandler);
        }
        if (e.key == 'Tab') {
            e.preventDefault();
            let closer = e.currentTarget.querySelector('.close');
            closer.focus();
        }
    }
    static styles = [
        accessibility,
        css `
        .alt_block {
            position: absolute;
            top: 0;
            right: 0;
            z-index: 100;
                
        }
        .alt_block.open {
            width: 100%;
            max-width: 320px;
        }

        .alt-block {
            position: relative;
            display: block;
        }

        .alt_trigger {
            background-color: var(--color-white,#fff);
            color: black;
            text-transform: uppercase;
            font-size: 0.8rem;
            padding: 0.1rem;
            min-width: 2rem;
            height: 2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px solid #ccc;
            position: absolute;
            top: 0;
            right: 0;
            text-align: left;
            line-height: 1;
            text-decoration: none;
            border-radius: 0;
            font-weight: 600;
            letter-spacing: 0.05em;
            cursor: pointer;
            font-family: "Montserrat", sans-serif;
        }

        .alt_modal {
            position: absolute;
            background-color: white;
            top: 0;
            right: 0;
            max-width: 90vw;
            padding: 2rem 1rem;
            opacity: 0;
            transform: scale(0);
            transition: opacity calc(var(--transition) / 2) ease,
                transform var(--move-transition) ease;
            transform-origin: 100% 0;
            visibility: hidden;
            box-shadow: 2px 2px 4px rgba(0,0,0,0.5);
        }

        .alt_block.open .alt_modal {
            opacity: 1;
            transform: scale(1);
            border: 1px solid #ccc;
            visibility: visible;
        }

        .alt_block.open .alt_trigger {
            border-bottom: none;
            border-left: none;
        }
        .close {
            background: #FFC845;
            color: #000;
            display: block;
            text-align: left;
            padding: 0.6rem 1rem;
            line-height: 1;
            text-decoration: none;
            border: none;
            border-radius: 0;
            text-transform: none;
            font-weight: 600;
            letter-spacing: 0.05em;
            cursor: pointer;
            font-family: "Montserrat", sans-serif;
            font-size: 1rem;
        }
        `
    ];
}
